module.exports = require("./crossfilter").crossfilter;



//////////////////
// WEBPACK FOOTER
// ./~/crossfilter2/index.js
// module id = 133
// module chunks = 0